import React from "react";
import { withRouter } from "react-router";
import postLandingPage from "../utils/Analytics";
import Analysis from "../Components/Analysis";
import LifeStyleAnalysis from "../Components/LifestyleAnalysis";
import midShield from "../assets/images/medium-shield.png";
import highShield from "../assets/images/high-shield.png";
import lowShield from "../assets/images/low-shield.png";
import progress from "../assets/images/progress.png";
import male from "../assets/images/male.png";
import female from "../assets/images/female.png";
import risk from "../assets/images/risk.png";
import healthy from "../assets/images/healthy.png";
import transformation from "../assets/images/transformation.png";
import orangeBorder from "../assets/images/orange-border.png";
import maleBMIgrey from "../assets/images/mbmi-grey.png";
import maleBMIorange from "../assets/images/mbmi-orange.png";
import maleBMIsoil from "../assets/images/mbmi-soil.png";
import maleBMIblood from "../assets/images/mbmi-blood.png";
import maleBMIgreen from "../assets/images/mbmi-green.png";
import femaleBMIgrey from "../assets/images/fmbmi-grey.png";
import femaleBMIorange from "../assets/images/fmbmi-orange.png";
import femaleBMIblood from "../assets/images/fmbmi-blood.png";
import femaleBMIsoil from "../assets/images/fmbmi-soil.png";
import femaleBMIgreen from "../assets/images/fmbmi-green.png";
import blank_rectangle from "../assets/images/blank_rectangle.png";

import bmiImg from "../assets/images/bmi/bmi.png";
import groupImg from "../assets/images/bmi/group.png";
import bodyfatImg from "../assets/images/bmi/newbodyfat.png";
import weightImg from "../assets/images/bmi/weight.png";
import optimium from "../assets/images/optimium.png";
import lifestyleDisease from "../assets/images/lifestyle-disease.png";
import brain from "../assets/images/brain.png";
import liver from "../assets/images/liver.png";
import bp from "../assets/images/bp.png";
import sleepAnalysis from "../assets/images/sleepAnalysis1.png";
import sleepAnalysis2 from "../assets/images/sleepAnalysis2.png";
import emotionalWellbeing from "../assets/images/emotional-wellbeing.png";
import healthliteracy from "../assets/images/rafiki.png";
import readytochange from "../assets/images/readytochange.png";
import lifestyleAnalysis1 from "../assets/images/lifestyleAnalysis1.png";
import lifestyleAnalysis2 from "../assets/images/lifestyleAnalysis2.png";
import lifestyleAnalysis3 from "../assets/images/lifestyleAnalysis3.png";
import lifestyleAnalysis4 from "../assets/images/lifestyleAnalysis4.png";
import heart from "../assets/images/heart.png";
import logo from "../assets/images/zyla.svg";
import star1 from "../assets/images/star1.png";
import star2 from "../assets/images/star2.png";
import star3 from "../assets/images/star3.png";
import ZylaBanner from "../Components/ZylaBanner";
import greenWeightImg from "../assets/images/bmi/green-weight-img.png";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import "./Score.css";
import GoldenBanner from "../Components/GoldenBanner";
import ChatBotServices from "../services/chatBotServices";
import { RequestCallbackCTA } from "../Components/RequestCallback";

const borderColor = {
  Good: "#7BA720",
  Poor: "#F34868",
  Average: "#F9A500",
};

class Score extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      response: {},
      gender: male,
      bmi: maleBMIgreen,
    };
    this.chatBotService = new ChatBotServices();
  }
  componentDidMount() {
    let slug = localStorage.getItem("slug");
    let url = new URLSearchParams(window.location.search);
    postLandingPage(50, url);
    this.chatBotService.getScore(
      slug,
      (response) => {
        let bmi;
        let genderImg;

        //handle bmi img change
        if (response.gender === 1) {
          genderImg = male;
          if (response.bmiAnalysis.bmi < 18.5) {
            bmi = maleBMIgrey;
          } else if (
            response.bmiAnalysis.bmi >= 18.5 &&
            response.bmiAnalysis.bmi <= 24.9
          ) {
            bmi = maleBMIgreen;
          } else if (
            response.bmiAnalysis.bmi > 24.9 &&
            response.bmiAnalysis.bmi <= 29.9
          ) {
            bmi = maleBMIorange;
          } else if (
            response.bmiAnalysis.bmi > 29.9 &&
            response.bmiAnalysis.bmi <= 34.9
          ) {
            bmi = maleBMIblood;
          } else {
            bmi = maleBMIsoil;
          }
        } else {
          genderImg = female;
          if (response.bmiAnalysis.bmi < 18.5) {
            bmi = femaleBMIgrey;
          } else if (
            response.bmiAnalysis.bmi >= 18.5 &&
            response.bmiAnalysis.bmi <= 24.9
          ) {
            bmi = femaleBMIgreen;
          } else if (
            response.bmiAnalysis.bmi > 24.9 &&
            response.bmiAnalysis.bmi <= 29.9
          ) {
            bmi = femaleBMIorange;
          } else if (
            response.bmiAnalysis.bmi > 29.9 &&
            response.bmiAnalysis.bmi <= 34.9
          ) {
            bmi = femaleBMIblood;
          } else {
            bmi = femaleBMIblood;
          }
        }
        setTimeout(() => {
          this.setState({
            response: { ...response },
            loading: false,
            gender: genderImg,
            bmi: bmi,
          });
        }, 3000);
      },
      (error) => {
        this.props.history.push("/");
        console.log("Error is ", error);
      }
    );
  }

  render() {
    return (
      <>
        {this.state.loading ? (
          <div className="loader">
            <Loader
              type="TailSpin"
              color="#00BFFF"
              height={100}
              width={100}
              // timeout={3000} //3 secs
            />
          </div>
        ) : (
          <div className="score-page-container">
            <RequestCallbackCTA />
            <header className="App-header">
              <div className="logo-wrapper">
                <img src={logo} className="App-logo" alt="logo" />
              </div>
              <div>
                <span className="health-score">Hello,</span>
                <span className="health-score inline-span">
                  {this.state.response.user.email}
                </span>
              </div>
            </header>
            <div className="score-container-upper-div">
              <h2 className="score-container-heading">YOUR HEALTH SCORE IS</h2>
              <div className="shield">
                <div className="shield-img">
                  <img
                    src={
                      this.state.response.overallScore < 30
                        ? lowShield
                        : this.state.response.overallScore >= 30 &&
                          this.state.response.overallScore <= 70
                        ? midShield
                        : highShield
                    }
                  />
                  <span
                    className="score-span"
                    style={{
                      color: `${
                        this.state.response.overallScore < 30
                          ? "#E52506"
                          : this.state.response.overallScore >= 30 &&
                            this.state.response.overallScore <= 70
                          ? "#E7C200"
                          : "#47C100"
                      }`,
                    }}
                  >
                    {this.state.response.overallScore}
                  </span>
                </div>
                <img src={star1} className="background-stars group1-star1" />
                <img src={star2} className="background-stars group1-star2" />
                <img src={star3} className="background-stars group1-star3" />
                <img src={star2} className="background-stars group2-star1" />
                <img src={star2} className="background-stars group2-star2" />
              </div>
            </div>
            <div className="score-container-lower-div">
              <div className="humanfigure">
                <img
                  src={this.state.gender}
                  style={{
                    left: `${(this.state.response.overallScore / 10) * 9.09}%`,
                  }}
                />
              </div>
              <div className="numbers">
                <span>0</span>
                <span>10</span>
                <span>20</span>
                <span>30</span>
                <span>40</span>
                <span>50</span>
                <span>60</span>
                <span>70</span>
                <span>80</span>
                <span>90</span>
                <span>100</span>
              </div>

              <div className="progressBar">
                <img src={progress} />
              </div>
              {/* <div className="myprogressBar"></div> */}
              <div className="emojibox">
                <div className="emojiImg">
                  <img src={risk} />
                </div>
                <div className="emojiImg">
                  <img src={transformation} />
                </div>
                <div className="emojiImg">
                  <img src={healthy} />
                </div>
                <div className="emojiImg">
                  <img src={optimium} />
                </div>
              </div>
              <div className="emojibox">
                <div className="emojiImg">
                  <span>Risk</span>
                </div>
                <div className="emojiImg">
                  <span>Transformation</span>
                </div>
                <div className="emojiImg">
                  <span>Healthy</span>
                </div>
                <div className="emojiImg">
                  <span>Optimum</span>
                </div>
              </div>
            </div>
            <div className="avaerage-score-box">
              <span className="avaerage-score-box-span-one">
                The first step towards good health starts with knowing the
                baseline.
              </span>
              <hr className="average-score-box-divider" />
              <span className="avaerage-score-box-span-one">
                Here is your health risk assesment report
              </span>
            </div>
            <div className="body-mass-index-container">
              <div className="body-mass-index-container-top-div">
                <span className="body-mass-index-container-top-div-span">
                  BMI- Body Mass Index
                </span>
                <div>
                  <img
                    src={orangeBorder}
                    className="body-mass-index-container-top-div-img"
                  />
                </div>

                <div className="body-mass-index-container-top-div-desc">
                  BMI is an indicator to gauge whether your weight is in healthy
                  proportion to your height.{" "}
                </div>
              </div>

              <img src={this.state.bmi} className="main-bmi-img" />
              <div className="bmi-lower-div">
                <div className="general-img-heading-box">
                  <img src={bmiImg} />
                  <div>
                    <span className="general-span-one">Your BMI is</span>
                    <span className="inline-span general-span-two">
                      {this.state.response.bmiAnalysis.bmi}
                    </span>
                  </div>
                </div>
                {/* <div className="general-img-heading-box">
                  <img src={groupImg} />
                  <div>
                    <span className="general-span-one">
                      Average BMI as per your age and gender is
                    </span>
                    <span className="inline-span general-span-two">
                      {this.state.response.bmiAnalysis.averageBmi}
                    </span>
                  </div>
                </div> */}
                <div className="general-img-heading-box">
                  <img src={bodyfatImg} />
                  <div>
                    <span className="general-span-one">
                      Your estimated body fat is
                    </span>
                    <span className="inline-span general-span-two">
                      {this.state.response.bmiAnalysis.bodyFat}&nbsp;%
                    </span>
                  </div>
                </div>
                <div className="general-img-heading-box">
                  <img src={greenWeightImg} />
                  <div>
                    <span className="general-span-one">
                      {`To achieve ideal BMI, target ${
                        this.state.response.bmiAnalysis.targetChange > 0
                          ? "to gain"
                          : "to lose"
                      }`}
                    </span>
                    <span className="inline-span general-span-two">
                      {this.state.response.bmiAnalysis.targetChange < 0
                        ? -this.state.response.bmiAnalysis.targetChange
                        : this.state.response.bmiAnalysis.targetChange}
                      &nbsp;kg
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <GoldenBanner />
            <div className="lifestyle-disease-container">
              <div className="body-mass-index-container-top-div">
                <span className="body-mass-index-container-top-div-span">
                  RISK OF LIFESTYLE DISEASE
                </span>
                <div>
                  <img
                    src={orangeBorder}
                    className="body-mass-index-container-top-div-img"
                  />
                </div>

                <div className="body-mass-index-container-top-div-desc">
                  We have used various scientific tools to determine your risk
                  of developing lifestyle diseases.
                </div>
              </div>
              <img src={lifestyleDisease} className="main-lifestyle-img" />
              <div className="bmi-lower-div">
                {this.state.response.lifestyleDisease.diabetes && (
                  <div className="general-img-heading-box">
                    <img src={bp} />
                    <div>
                      <span className="general-span-one">
                        Your 10-year risk of developing type-2 diabetes is:
                      </span>
                      <span className="inline-span lifestyle-general-span-two">
                        {this.state.response.lifestyleDisease.diabetes.tag}
                      </span>
                    </div>
                  </div>
                )}
                {this.state.response.lifestyleDisease.cvd && (
                  <div className="general-img-heading-box">
                    <img src={heart} />
                    <div>
                      <span className="general-span-one">
                        Your 10-year risk of developing a cardio-vascular
                        disease is:
                      </span>
                      <span className="inline-span lifestyle-general-span-two">
                        {this.state.response.lifestyleDisease.cvd.tag}
                      </span>
                    </div>
                  </div>
                )}
                {this.state.response.lifestyleDisease.hypertension && (
                  <div className="general-img-heading-box">
                    <img src={brain} />
                    <div>
                      <span className="general-span-one">
                        Your 4-year risk of developing hypertension is:
                      </span>
                      <span className="inline-span lifestyle-general-span-two">
                        {this.state.response.lifestyleDisease.hypertension.tag}
                      </span>
                    </div>
                  </div>
                )}
                {this.state.response.lifestyleDisease.fattyLiver && (
                  <div className="general-img-heading-box">
                    <img src={liver} />
                    <div>
                      <span className="general-span-one">
                        Your risk of developing fatty liver is:
                      </span>
                      <span className="inline-span lifestyle-general-span-two">
                        {this.state.response.lifestyleDisease.fattyLiver.tag}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <LifeStyleAnalysis
              heading="Lifestyle analysis"
              description="Dietary Routine"
              dietaryImg={lifestyleAnalysis2}
              bgColor="#FFFBF4"
              img={blank_rectangle}
              addictionImg={lifestyleAnalysis4}
              physicalActivityImg={lifestyleAnalysis1}
              analysis={this.state.response.lifestyleAnalysis}
            />
            <Analysis
              heading="Sleep analysis"
              description="Sleep quality has a very strong correlation between your energy levels and long term health. Poor sleep quality can also lead to early onset of cardio metabolic diseases."
              analysisImg={
                this.state.response.sleepAnalysis.tag === "Poor"
                  ? sleepAnalysis2
                  : sleepAnalysis
              }
              remarks={this.state.response.sleepAnalysis.text}
              bgColor="white"
              borderColor={borderColor[this.state.response.sleepAnalysis.tag]}
              tag={this.state.response.sleepAnalysis.tag}
            />
            <Analysis
              heading="Emotional well-being "
              description="Emotional health is an important part of overall health. People who are emotionally healthy are in control of their thoughts, feelings, and behaviors. They're able to cope with challenges better. They typically excel in their professional career as well."
              analysisImg={emotionalWellbeing}
              remarks={this.state.response.emotionalAnalysis.text}
              bgColor="#FFFBF4"
              borderColor={
                borderColor[this.state.response.emotionalAnalysis.tag]
              }
              tag={this.state.response.emotionalAnalysis.tag}
            />
            <Analysis
              heading="Health literacy"
              description="Health literacy is the measure of how well you are aware of your health care needs. Higher the score means that you are more likely to care for yourself if you are aware of your health conditions."
              analysisImg={healthliteracy}
              remarks={this.state.response.healthLiteracy.text}
              bgColor="white"
              borderColor={borderColor[this.state.response.healthLiteracy.tag]}
              tag={this.state.response.healthLiteracy.tag}
            />
            {/* <Analysis
              heading="Readiness to change"
              description="Readiness to change is a measure of your ability to own your health and work positively to improve your health score."
              analysisImg={readytochange}
              remarks="High: You are among the more health aware people I have come across. Given that you know your health risk score, I am certain that you will work towards improving it!"
              bgColor="#FFFBF4"
            /> */}
            <ZylaBanner />
          </div>
        )}
      </>
    );
  }
}

export default withRouter(Score);
